module.exports = __webpack_public_path__ + "img/Product03.1a4d42a9.png";